/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { Fragment, useContext } from 'react';
import { NotificationLabels } from '@bb/domain/dist/types/AppointmentConfig';
import styled from 'styled-components';
import { Checkbox, Text, Title } from 'components';
import ContactModalContext from './ContactModalContext';

const NOTIFICATION_KEY_LABEL_LIST: {
  key: NotificationLabels;
  label: string;
}[] = [
  { key: 'Booked', label: 'Requested' },
  { key: 'Confirmed', label: 'Confirmed' },
  { key: 'Cancelled', label: 'Cancelled' },
  { key: 'Deny', label: 'Deny' },
  { key: 'Time Change', label: 'Time Change' },
  { key: 'Action Required', label: 'Reminders' },
  { key: 'Feedback Collected', label: 'Feedback Collected' },
];

const Notifications: React.FC = () => {
  const { contact, setContact } = useContext(ContactModalContext);

  return (
    <div>
      <Title level={2}>Send Notifications</Title>

      <SettingsContainer>
        {NOTIFICATION_KEY_LABEL_LIST.map(({ key, label }) => (
          <Fragment key={key}>
            <Text strong>{label}</Text>
            <Checkbox
              checked={Boolean(contact.notifications[key])}
              onChange={e =>
                setContact({
                  ...contact,
                  notifications: {
                    ...contact.notifications,
                    [key]: e.target.checked,
                  },
                })
              }
            />
          </Fragment>
        ))}
      </SettingsContainer>
    </div>
  );
};

export default Notifications;

const SettingsContainer = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr auto;
  margin-right: 10%;
`;
